import * as types from "./navigationActionTypes";

export const setSavedPersistentState = (persistentState) => ({
  type: types.SAVE_PERSISTENT_STATE,
  payload: persistentState,
});
